// extracted by mini-css-extract-plugin
export default {"plus":"Faq_plus__01wIQ","minus":"Faq_minus__5tEr5"};